"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CollectionsCollection_1 = require("./Collections/CollectionsCollection");
const ResourceFilterableCollection_1 = require("./Collections/ResourceFilterableCollection");
function addTo(collection, hashList, item) {
    if (hashList.indexOf(item.iri) === -1) {
        collection.push(item);
        hashList.push(item.iri);
    }
}
function discoverCollectionsFrom(hypermedia) {
    const collectionIris = [];
    const collections = [];
    for (const control of hypermedia) {
        if (control.type.isCollection) {
            addTo(collections, collectionIris, control);
        }
        else if (!!control.collections) {
            for (const linkedCollection of control.collections) {
                addTo(collections, collectionIris, linkedCollection);
            }
        }
    }
    return collections;
}
/**
 * Provides a default implementation of the {@link IHypermediaContainer} interface.
 * @class
 */
class HypermediaContainer extends ResourceFilterableCollection_1.default {
    /**
     * Initializes a new instance of the {@link HypermediaContainer} class.
     * @param {Response} response Raw response.
     * @param {IResource} rootResource Main resource associated with the requested Url.
     * @param {Iterable<IResource>} hypermedia Hypermedia controls to be stored within this container.
     */
    constructor(response, rootResource, hypermedia) {
        super(hypermedia);
        this.response = response;
        this.iri = rootResource.iri;
        this.type = rootResource.type;
        this.operations = rootResource.operations;
        this.collections = new CollectionsCollection_1.default(discoverCollectionsFrom(hypermedia));
        this.links = rootResource.links;
        const collection = rootResource;
        if (!!collection.members) {
            this.collection = collection;
        }
    }
    /** @inheritDoc */
    get headers() {
        return this.response.headers;
    }
    /** @inheritDoc */
    get url() {
        return this.response.url;
    }
    /** @inheritDoc */
    get status() {
        return this.response.status;
    }
    /** @inheritDoc */
    get body() {
        return this.response.body;
    }
    /** @inheritDoc */
    get bodyUsed() {
        return this.response.bodyUsed;
    }
    /** @inheritDoc */
    get view() {
        return !!this.collection ? this.collection.view : null;
    }
    /** @inheritDoc */
    get members() {
        return !!this.collection ? this.collection.members : null;
    }
    /** @inheritDoc */
    get manages() {
        return !!this.collection ? this.collection.manages : null;
    }
    /** @inheritDoc */
    get totalItems() {
        return !!this.collection ? this.collection.totalItems : 0;
    }
    /** @inheritDoc */
    getIterator() {
        return !!this.collection ? this.collection.getIterator() : null;
    }
    /** @inheritDoc */
    arrayBuffer() {
        return this.response.arrayBuffer();
    }
    /** @inheritDoc */
    blob() {
        return this.response.blob();
    }
    /** @inheritDoc */
    json() {
        return this.response.json();
    }
    /** @inheritDoc */
    text() {
        return this.response.text();
    }
}
exports.default = HypermediaContainer;
//# sourceMappingURL=HypermediaContainer.js.map